import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import axios from "../../../axios/index";

// custom hooks
import usePriceSeprator from "../../../hooks/usePriceSeparator";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// styles
import styles from "../DashboardFileManagement/DashboardFileManagement.module.css";

// Re Useable Components
import DashboardSideMenu from "../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../DashboardReuseAbleComponents/DashboardHeader";
import FileManagementBtns from "../DashboardFileManagement/FileManagementBtns";
import FileManagmentCards from "../DashboardFileManagement/FileManagmentCards";
import ShowProfileModal from "../DashboardFileManagement/CardDetail/ShowProfileModal";
import FilterModal from "../DashboardFileManagement/FilterModal/FilterModal";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import CustomPagination from "../../CustomPagination/CustomPagination";

const PlacesFiles = () => {
  const [tableType, setTableType] = useState(localStorage.getItem("tableType") || "card");
  // console.log(localStorage.getItem("tableType") || "card", localStorage.getItem("tableType"));

  // useEffect(() => {
  //   setTableType(localStorage.getItem("tableType") || "card");
  // }, []);

  const { userToken, userData } = useContext(UserContext);
  const [cardData, setCardData] = useState([]);
  const [isShowSidebar, setIsShowSidebar] = useState(true);

  console.log("cardData", cardData);

  const [page, setPage] = useState(
    JSON.parse(sessionStorage.getItem("pageData")) || {
      pageNumber: 1,
      pageCount: 5,
    }
  );
  const [isLoading, setIsLoading] = useState(true);

  const [query, setQuery] = useState(sessionStorage.getItem("searchData") || "");
  const [modalShow, setModalShow] = useState(false);
  const [filterParams, setFilterParams] = useState(
    JSON.parse(sessionStorage.getItem("filters")) || {
      place: "",
      room: "",
      floor: "",
      startPrice: "",
      fileCode: "",
      endPrice: "",
      metraj: [0, 100000],
      startMortaje: "",
      endMortaje: "",
      startRent: "",
      endRent: "",
      showList: false,
      showModal: false,
      dataChanged: false,
    }
  );
  const [filterCardsByCategory, setFilterCardsByCategory] = useState({
    onSale: true,
    forRent: false,
  });

  let [selectedCategories, setSelectedCategories] = useState(
    sessionStorage.getItem("categories") === null ? [] : JSON.parse(sessionStorage.getItem("categories"))
  );
  let [selectedSubCategory, setSelectedSubCategory] = useState(
    sessionStorage.getItem("subCategory") === null ? 0 : Number(sessionStorage.getItem("subCategory"))
  );
  let [selectedMainCategory, setSelectedMainCategory] = useState(
    sessionStorage.getItem("mainCategory") === null ? 0 : Number(sessionStorage.getItem("mainCategory"))
  );
  let [dealType, setDealType] = useState(sessionStorage.getItem("dealType") === null ? -1 : Number(sessionStorage.getItem("dealType")));
  let [categoriesData, setCategoriesData] = useState([]);

  useEffect(() => {
    if (tableType !== localStorage.getItem("tableType")) {
      setTableType(localStorage.getItem("tableType") || "card");
      localStorage.setItem("tableType", localStorage.getItem("tableType") || "card");
    }
  }, [tableType, selectedSubCategory]);

  let updateCategories = useCallback((value, type) => {
    console.log(value);
    switch (type) {
      case 0:
        if (value != dealType) {
          setDealType(value);
          setSelectedMainCategory(0);
          setSelectedSubCategory(0);
          setSelectedCategories([]);
          //dataHandler();
        }
        break;
      case 1:
        if (value != selectedMainCategory) {
          setSelectedMainCategory(value);
          setSelectedSubCategory(0);
          setSelectedCategories([]);
          //dataHandler();
        }
        break;
      case 2:
        if (value != selectedSubCategory) {
          setSelectedSubCategory(value);
          setSelectedCategories([]);
          //dataHandler();
        }
        break;
      case 3:
        if (value !== selectedCategories) {
          setSelectedCategories(value);
          //dataHandler();
        }
        break;
    }
  });

  function generateCategoriesString() {
    let queryString = "";

    if (dealType != -1) {
      queryString += "&DealType=" + dealType;

      if (selectedMainCategory != 0) {
        queryString += "&MainCategory=" + selectedMainCategory;

        if (selectedSubCategory != 0) {
          queryString += "&SubCategory=" + selectedSubCategory;

          selectedCategories.forEach(region => {
            queryString += "&RegionCategories=" + region;
          });
        }
      }
    }
    return queryString;
  }

  const cancelTokenRef = useRef(null);

  const getDataHandler = useCallback(async () => {
    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel();
    }

    cancelTokenRef.current = axios.CancelToken.source();
    let categoryIdString = "";
    if (selectedCategories.length > 0) {
      selectedCategories.forEach((id, index) => {
        categoryIdString += `&CategoryId=${id}`;
      });
    }
    try {
      const { data } = await axios.get(
        `Consultant/ConsultantAreaFile?search=${query}&EstateType=${dealType == 1 ? "2" : "1"}&Zone=${filterParams.place}${
          filterParams.startPrice && `&StartTotalPrice=${filterParams.startPrice}`
        }${filterParams.endPrice && `&EndTotalPrice=${filterParams.endPrice}`}&MinimumArea=${filterParams.metraj[0]}&MaximumArea=${
          filterParams.metraj[1]
        }&BedRoomCount=${filterParams.room !== undefined ? filterParams.room : ""}&FileCode=${filterParams.fileCode ? filterParams.fileCode : ""}&Floor=${
          filterParams.floor !== undefined ? filterParams.floor : ""
        }&Take=6&OrderBy=2${categoryIdString}${generateCategoriesString()}`,
        {
          headers: { authorization: "Bearer " + userToken },
        }
      );
      const filesData = data?.data.data || [];
      setCardData(filesData);
      setPage({ pageNumber: 1, pageCount: data.data.pageCount });
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  }, [userToken, filterCardsByCategory.onSale, filterCardsByCategory.forRent, userData.id, selectedCategories]);

  useEffect(() => {
    getDataHandler();
  }, [getDataHandler]);

  useEffect(() => {
    sessionStorage.setItem("pageData", JSON.stringify(page));
  }, [page]);

  useEffect(() => {
    sessionStorage.setItem("searchData", query);
  }, [query]);

  useEffect(() => {
    axios
      .get("Category", {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .then(res => {
        setCategoriesData(res.data.data);
        setSelectedCategories(sessionStorage.getItem("categories") === null ? [] : JSON.parse(sessionStorage.getItem("categories")));
        setDealType(sessionStorage.getItem("dealType") === null ? -1 : Number(sessionStorage.getItem("dealType")));
        setSelectedMainCategory(sessionStorage.getItem("mainCategory") === null ? 0 : Number(sessionStorage.getItem("mainCategory")));
        setSelectedSubCategory(sessionStorage.getItem("subCategory") === null ? 0 : Number(sessionStorage.getItem("subCategory")));
      });
  }, []);

  useEffect(() => {
    if (selectedMainCategory != null) {
      sessionStorage.setItem("mainCategory", String(selectedMainCategory));
    }
    if (selectedSubCategory != null) {
      sessionStorage.setItem("subCategory", String(selectedSubCategory));
    }
    if (dealType != null) {
      sessionStorage.setItem("dealType", String(dealType));
    }
    sessionStorage.setItem("categories", JSON.stringify(selectedCategories));
    if (dealType != -1) {
      dataHandler();
    }
  }, [selectedCategories, selectedMainCategory, selectedSubCategory, dealType]);

  useEffect(() => {
    if (!selectedSubCategory) setTableType("card");
  }, [selectedSubCategory]);

  useEffect(() => {
    sessionStorage.setItem("filters", JSON.stringify(filterParams));
  }, [filterParams]);

  console.log(cardData);

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      <FilterModal
        show={filterParams.showModal}
        placesFiles={true}
        filterParams={filterParams}
        dataHandler={dataHandler}
        setFilterParams={setFilterParams}
        filterCardsByCategory={filterCardsByCategory}
        deleteFilterHandler={deleteFilterHandler}
        onHide={() =>
          setFilterParams(prev => {
            return { ...prev, showModal: false };
          })
        }
      />

      {isLoading ? (
        <div className={styles.loader_container}>
          <div className={styles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className={isShowSidebar ? "col-md-9" : "col-md-12"}>
              <div className={`mt-3 px-md-0 px-2 ${styles.file_cards_container}`}>
                <DashboardHeader
                  setIsShowSidebar={setIsShowSidebar}
                  isShowSidebar={isShowSidebar}
                  onClick={() => setModalShow(true)}
                  class="px-3"
                  query={query}
                  setQuery={setQuery}
                  searchHandler={searchHandler}
                />
                <FileManagementBtns
                  tableType={tableType}
                  setTableType={setTableType}
                  selectedSubCategory={selectedSubCategory}
                  categoriesData={categoriesData}
                  categories={selectedCategories}
                  mainCategory={selectedMainCategory}
                  subCategory={selectedSubCategory}
                  dealType={dealType}
                  updateFunction={updateCategories}
                  title="فایل های منطقه"
                  setFilterParams={setFilterParams}
                  setCardData={setCardData}
                  userToken={userToken}
                  filterCardsByCategory={filterCardsByCategory}
                  cardHandler={cardHandler}
                  setIsLoading={setIsLoading}
                  class="px-3"
                  placesFiles={true}
                />
                <FileManagmentCards
                  dealType={dealType}
                  selectedSubCategory={selectedSubCategory}
                  tableType={tableType}
                  cardData={cardData}
                  isLoading={isLoading}
                  filterCardsByCategory={filterCardsByCategory}
                  usePriceSeprator={usePriceSeprator}
                />
                <Stack
                  className={styles.pagination}
                  spacing={1}
                  sx={{
                    direction: "ltr",
                    bottom: "0",
                    height: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center !important",
                  }}>
                  <CustomPagination count={page.pageCount} page={page.pageNumber} onChange={paginationHandler} variant="outlined" shape="rounded" />
                  <div dir="rtl">
                    انتخاب صفحه:{" "}
                    <input
                      style={{
                        width: "50px",
                        border: "1px solid #aaa",
                        borderRadius: "10px",
                        height: "35px",
                        textAlign: "center",
                      }}
                      type="number"
                      max={page.pageCount}
                      min={1}
                      defaultValue={page.pageNumber}
                      id="paginationInput"
                      onKeyDown={paginationInputEnterHandler}
                      // onChange={paginationInputHandler}
                    />
                  </div>
                </Stack>
              </div>
            </div>
            <div
              className={isShowSidebar ? "col-md-3" : "hidden"}
              style={{
                display: isShowSidebar ? "block" : "none",
              }}>
              {/* sideMenu starts */}
              <DashboardSideMenu placesFiles setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function paginationInputEnterHandler(e) {
    if (e.key === "Enter") {
      console.log("target", e.target.value);

      paginationHandler(undefined, e.target.value);
      const url = new URL(window.location);
      url.searchParams.set("page", e.target.value);
      window.history.pushState({}, "", url);
    }
  }

  async function searchHandler() {
    setIsLoading(true);
    let queryUpdated = query?.replace(/[۰-۹]/g, d => "0123456789".indexOf(d));
    try {
      const { data } = await axios.get(
        `Consultant/ConsultantAreaFile?search=${query}&EstateType=${dealType == 1 ? "2" : "1"}&Zone=${filterParams.place}${
          filterParams.startPrice && `&StartTotalPrice=${filterParams.startPrice}`
        }${filterParams.endPrice && `&EndTotalPrice=${filterParams.endPrice}`}&MinimumArea=${filterParams.metraj[0]}&MaximumArea=${
          filterParams.metraj[1]
        }&BedRoomCount=${filterParams.room !== undefined ? filterParams.room : ""}&FileCode=${filterParams.fileCode ? filterParams.fileCode : ""}&Floor=${
          filterParams.floor !== undefined ? filterParams.floor : ""
        }&Take=6&OrderBy=2${generateCategoriesString()}`,
        {
          headers: { authorization: "Bearer " + userToken },
        }
      );

      setPage({
        pageNumber: data.data.currentPage,
        pageCount: data.data.pageCount,
      });
      const estatesData = data?.data.data || [];
      setCardData(estatesData);
      setIsLoading(false);
    } catch (error) {
      //console.error(error);
    }
    setIsLoading(false);
  }

  function cardHandler(event) {
    if (event.target.id === "onSale") {
      setFilterCardsByCategory(prev => {
        return { ...prev, onSale: true, forRent: false };
      });
    } else if (event.target.id === "forRent") {
      setFilterCardsByCategory(prev => {
        return { ...prev, forRent: true, onSale: false };
      });
    }
  }

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getSalesData = await axios.get(
      `Consultant/ConsultantAreaFile?search=${query}&PageId=${value}&EstateType=${dealType == 1 ? "2" : "1"}&Zone=${filterParams.place}${
        filterParams.startPrice && `&StartTotalPrice=${filterParams.startPrice}`
      }${filterParams.endPrice && `&EndTotalPrice=${filterParams.endPrice}`}&MinimumArea=${filterParams.metraj[0]}&MaximumArea=${
        filterParams.metraj[1]
      }&BedRoomCount=${filterParams.room !== undefined ? filterParams.room : ""}&FileCode=${filterParams.fileCode ? filterParams.fileCode : ""}&Floor=${
        filterParams.floor !== undefined ? filterParams.floor : ""
      }&Take=6&OrderBy=2${generateCategoriesString()}`,
      {
        headers: { authorization: "Bearer " + userToken },
      }
    );
    const salesData = getSalesData.data.data.data;
    setCardData(salesData);
    setIsLoading(false);
    setPage({
      pageCount: getSalesData.data.data.pageCount,
      pageNumber: value,
    });
  }

  async function dataHandler() {
    if (dealType != 1) {
      setIsLoading(true);
      const getSalesData = await axios.get(
        `Consultant/ConsultantAreaFile?search=${query}&EstateType=2&Zone=${filterParams.place}${
          filterParams.startPrice && `&StartTotalPrice=${filterParams.startPrice}`
        }${filterParams.endPrice && `&EndTotalPrice=${filterParams.endPrice}`}&MinimumArea=${filterParams.metraj[0]}&MaximumArea=${
          filterParams.metraj[1]
        }&BedRoomCount=${filterParams.room !== undefined ? filterParams.room : ""}&FileCode=${filterParams.fileCode ? filterParams.fileCode : ""}&Floor=${
          filterParams.floor !== undefined ? filterParams.floor : ""
        }&OrderBy=2&Take=6${generateCategoriesString()}`,
        {
          headers: { authorization: "Bearer " + userToken },
        }
      );
      const salesData = getSalesData.data.data.data;
      setCardData(salesData);
      setIsLoading(false);
    } else if (dealType == 1) {
      setIsLoading(true);
      const getSalesData = await axios.get(
        `Consultant/ConsultantAreaFile?search=${query}&EstateType=1&Zone=${filterParams.place}${
          filterParams.startMortaje && `&StartMortgagePrice=${filterParams.startMortaje}`
        }${filterParams.endMortaje && `&EndMortgagePrice=${filterParams.endMortaje}`}${filterParams.startRent && `&StartRentPrice=${filterParams.startRent}`}${
          filterParams.endRent && `&EndRentPrice=${filterParams.endRent}`
        }&MinimumArea=${filterParams.metraj[0]}&MaximumArea=${filterParams.metraj[1]}&BedRoomCount=${
          filterParams.room !== undefined ? filterParams.room : ""
        }&FileCode=${filterParams.fileCode ? filterParams.fileCode : ""}&Floor=${
          filterParams.floor !== undefined ? filterParams.floor : ""
        }&OrderBy=2&Take=6${generateCategoriesString()}`,
        {
          headers: { authorization: "Bearer " + userToken },
        }
      );
      const salesData = getSalesData.data.data.data;
      setCardData(salesData);
      setIsLoading(false);
    }
  }

  async function deleteFilterHandler(params) {
    setIsLoading(true);
    const getSalesData = await axios.get(
      `Consultant/ConsultantAreaFile?search=${query}&EstateType=${dealType == 1 ? "2" : "1"}&Zone=${filterParams.place}${
        filterParams.startPrice && `&StartTotalPrice=${filterParams.startPrice}`
      }${filterParams.endPrice && `&EndTotalPrice=${filterParams.endPrice}`}&MinimumArea=${filterParams.metraj[0]}&MaximumArea=${
        filterParams.metraj[1]
      }&BedRoomCount=${filterParams.room !== undefined ? filterParams.room : ""}&FileCode=${filterParams.fileCode ? filterParams.fileCode : ""}&Floor=${
        filterParams.floor !== undefined ? filterParams.floor : ""
      }&Take=6&OrderBy=2${generateCategoriesString()}`,
      {
        headers: { authorization: "Bearer " + userToken },
      }
    );
    const salesData = getSalesData.data.data.data;
    setCardData(salesData);
    setIsLoading(false);
  }
};

export default PlacesFiles;
